import React from 'react';
import { useCurrentPreviewMetadata } from 'js/file_viewer/core/queries/preview_metadata';
import { useLinkfileUriQuery } from 'js/file_viewer/core/queries/riviera_preview_types/linkfile';
import { asyncComponent } from 'js/file_viewer/core/utils/suspense';
import { useDownloadSucceeded } from 'js/file_viewer/hooks/lifecycle_logging';
import { useRivieraTiming } from 'js/file_viewer/logging/hooks';
const AsyncPreviewLinkfile = asyncComponent('PreviewLinkfile', () => import('js/file_viewer/preview_linkfile/preview_linkfile'));
export const AsyncPreviewLinkfileWithLifecycleLogging = (props) => {
    const { previewKey, previewSessionId } = props;
    const previewData = useCurrentPreviewMetadata();
    const result = useLinkfileUriQuery(previewKey, previewData);
    useDownloadSucceeded(previewSessionId, result.isSuccess);
    useRivieraTiming(result, previewKey, previewData);
    return React.createElement(AsyncPreviewLinkfile, { ...props, linkfileResult: result });
};
AsyncPreviewLinkfileWithLifecycleLogging.displayName = "AsyncPreviewLinkfileWithLifecycleLogging"
//# sourceMappingURL=async_preview_linkfile.preenvesnextjs.map
